module.exports = __webpack_public_path__ + "img/slider_diamond_contractor_large.b2818a25.png";